/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HchbPatientRequestList } from './HchbPatientRequestList';
import {
    HchbPatientRequestListFromJSON,
    HchbPatientRequestListFromJSONTyped,
    HchbPatientRequestListToJSON,
    HchbPatientRequestListToJSONTyped,
} from './HchbPatientRequestList';

/**
 * 
 * @export
 * @interface FindAllHchbPatientRequests200Response
 */
export interface FindAllHchbPatientRequests200Response {
    /**
     * 
     */
    data?: HchbPatientRequestList;
}

/**
 * Check if a given object implements the FindAllHchbPatientRequests200Response interface.
 */
export function instanceOfFindAllHchbPatientRequests200Response(value: object): value is FindAllHchbPatientRequests200Response {
    return true;
}

export function FindAllHchbPatientRequests200ResponseFromJSON(json: any): FindAllHchbPatientRequests200Response {
    return FindAllHchbPatientRequests200ResponseFromJSONTyped(json, false);
}

export function FindAllHchbPatientRequests200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllHchbPatientRequests200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : HchbPatientRequestListFromJSON(json['data']),
    };
}

export function FindAllHchbPatientRequests200ResponseToJSON(json: any): FindAllHchbPatientRequests200Response {
    return FindAllHchbPatientRequests200ResponseToJSONTyped(json, false);
}

export function FindAllHchbPatientRequests200ResponseToJSONTyped(value?: FindAllHchbPatientRequests200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': HchbPatientRequestListToJSON(value['data']),
    };
}

